import type { BankAccountStatusUnionType } from '@api';

type GetBankAccountStatusColorReturnType = {
  backgroundColor: string;
  textColor: string;
};

export const getBankAccountStatusColor = (
  status: BankAccountStatusUnionType
): GetBankAccountStatusColorReturnType => {
  switch (status) {
    case 'PENDING':
      return { backgroundColor: '#FFEBC2', textColor: '#453007' };
    case 'ACTIVE':
      return { backgroundColor: '#C7F5D9', textColor: '#0C4121' };
    case 'DELETED':
      return { backgroundColor: '#FDD9DE', textColor: '#7A0619' };
  }
};
